import { ptsd781aNameTitle } from '../content/ptsdClassification';

export const uiSchema = {
  'ui:title': ptsd781aNameTitle,
  'ui:description':
    'Now we’re going to ask you questions about changes in your physical, mental, professional, and social behavior as a result of the event.',
};

export const schema = { type: 'object', properties: {} };
